import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import Dashboard from "@/pages/Dashboard";
import LiveNow from "@/pages/LiveNow";
import PlayerDetail from "@/pages/PlayerDetail";
import Watchlist from "@/pages/Watchlist";
import Results from "@/pages/Results";
import Paywall from "@/pages/Paywall";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import { Login, Register } from "@/pages/Auth";
import { AuthProvider, useAuth, isSubscribed } from "@/context/AuthContext";

function ProtectedRoute({ children, requireSubscription = true }) {
  const { user, loading } = useAuth();
  const loc = useLocation();
  if (loading || user === null) {
    return <div className="max-w-[1400px] mx-auto px-6 py-20 text-[#A1A1AA]">Loading…</div>;
  }
  if (user === false) {
    return <Navigate to="/login" state={{ from: loc.pathname }} replace />;
  }
  if (requireSubscription && !isSubscribed(user)) {
    return <Navigate to="/paywall" replace />;
  }
  return children;
}

function Shell() {
  return (
    <>
      <Header />
      <main className="min-h-[calc(100vh-4rem-6rem)]">
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/paywall" element={<ProtectedRoute requireSubscription={false}><Paywall /></ProtectedRoute>} />
          <Route path="/billing/success" element={<ProtectedRoute requireSubscription={false}><Paywall /></ProtectedRoute>} />
          <Route path="/billing/cancel" element={<ProtectedRoute requireSubscription={false}><Paywall /></ProtectedRoute>} />

          <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/live" element={<ProtectedRoute><LiveNow /></ProtectedRoute>} />
          <Route path="/player/:id" element={<ProtectedRoute><PlayerDetail /></ProtectedRoute>} />
          <Route path="/watchlist" element={<ProtectedRoute><Watchlist /></ProtectedRoute>} />
          <Route path="/results" element={<ProtectedRoute><Results /></ProtectedRoute>} />
        </Routes>
      </main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="App min-h-screen bg-[#0A0A0A]" data-testid="app-root">
      <BrowserRouter>
        <AuthProvider>
          <Shell />
        </AuthProvider>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#0A0A0A",
            border: "1px solid #27272A",
            color: "#fff",
            borderRadius: 0,
            fontFamily: "Manrope, sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
